/** Breakpoint pixel values */
export const breakpointValues = {
  mobile: 0,
  mobileSmall: 420,
  tablet: 768,
  desktop: 1024,
  wide: 1440
} as const;

/** Named media queries for use in style() or selectors */
export const breakpoints = {
  mobile: `screen and (min-width: ${breakpointValues.mobile}px)`,
  mobileOnly: `screen and (max-width: ${breakpointValues.mobileSmall}px)`,
  underTablet: `screen and (max-width: ${breakpointValues.tablet - 1}px)`,
  tablet: `screen and (min-width: ${breakpointValues.tablet}px)`,
  desktop: `screen and (min-width: ${breakpointValues.desktop}px)`,
  wide: `screen and (min-width: ${breakpointValues.wide}px)`
};
